module.exports = __webpack_public_path__ + "0af5d249/img/note-list-icon.961c1485.svg";